var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoIdentityDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_identitty_document",
    d: "M15.937,3H2.063A2.1,2.1,0,0,0,0,5.139v9.722A2.1,2.1,0,0,0,2.063,17H15.937A2.1,2.1,0,0,0,18,14.861V5.139A2.1,2.1,0,0,0,15.937,3ZM5.625,6.111a1.946,1.946,0,0,1,0,3.889,1.946,1.946,0,0,1,0-3.889ZM9,13.306a.573.573,0,0,1-.562.583H2.813a.573.573,0,0,1-.562-.583v-.389a2.1,2.1,0,0,1,2.063-2.139H6.937A2.1,2.1,0,0,1,9,12.917Zm6.187.583H11.063a.584.584,0,0,1,0-1.167h4.125a.584.584,0,0,1,0,1.167Zm0-3.111H11.063a.584.584,0,0,1,0-1.167h4.125a.584.584,0,0,1,0,1.167Zm0-3.111H11.063a.584.584,0,0,1,0-1.167h4.125a.584.584,0,0,1,0,1.167Z",
    transform: "translate(0 -3)",
    fill: "#74276b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoIdentityDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_identity_document.5b233d7ef3381efbb5a88370ab96f2cf.svg";